import React from 'react'
import styled from 'styled-components'
import { Grid } from 'semantic-ui-react'

//@ts-ignore
import { GridContainer } from 'shared/StyledComponents'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'
import { constants as DCConstants } from '../../../DetailsContainer'
import { translateBase, icon } from '../../helpers'

import Relations from './Relations'
import Insurances from './Insurances'
import Representatives from './Representatives'

import { RelationshipProps } from '../../types'

const Wrapper = styled.div`
  height: 100%;
  position: relative;
`
const myStyle = {
  height: '100%',
}

const style50 = {
  height: '49%',
}

@withConstantPermissions('CLIENT_DELEGATE_VIEW as CanView')
class Relationships extends React.PureComponent<RelationshipProps> {
  render = () => {
    const {
      ID,
      hash,
      CanView,
      data: { base, relations, insurances, linkedfiles },
    } = this.props
    return (
      <Wrapper>
        <GridContainer style={myStyle}>
          <Grid columns={1} style={style50}>
            <Grid.Column className="u-flex">
              <Relations
                base={base}
                data={relations}
                ID={ID}
                hash={hash}
                instanceName={`${DCConstants.DetailsGridPrefixes.client}-${ID}-Relations`}
                style={myStyle}
              />
            </Grid.Column>
          </Grid>
          {base.ClientTypeID === 3 && CanView ? (
            <Grid columns={2} style={style50}>
              <Grid.Column className="u-flex">
                <Insurances
                  data={insurances}
                  instanceName={`${DCConstants.DetailsGridPrefixes.client}-${ID}-Insurances`}
                />
              </Grid.Column>

              <Grid.Column className="u-flex">
                <Representatives
                  //@ts-ignore
                  ID={ID}
                  linkedfiles={linkedfiles}
                  hash={hash}
                  data={relations}
                  instanceName={`${DCConstants.DetailsGridPrefixes.client}-${ID}-Delegates`}
                />
              </Grid.Column>
            </Grid>
          ) : (
            <Grid columns={1} style={style50}>
              <Insurances
                data={insurances}
                instanceName={`${DCConstants.DetailsGridPrefixes.client}-${ID}-Insurances`}
              />
            </Grid>
          )}
        </GridContainer>
      </Wrapper>
    )
  }
}

//@ts-ignore
Relationships.config = {
  title: () => translateBase('tb_relations'),
  name: 'relations_insurances',
  component: Relationships,
  api: ['base', 'relations', 'insurances', 'linkedfiles'],
  icon: icon('tb_relations'),
}

export default Relationships
